<script>
  import { _ } from 'svelte-i18n';
  import { previews_nav_filters, previews_tags_filter, previews_tags_filter_operator, previews_are_google_fonts, detected_fonts, system_fonts, modals, previews_storefronts_filter, hobby_font_limit, user_installed_fonts_count, previews_search_filter, user_valid } from './../stores'
  import SelectDeselectAll from './SelectDeselectAll.svelte'
  import PreviewsStepperButton from './PreviewsStepperButton.svelte'
  import { isEmpty } from 'lodash'
  let hovering = false
  let just_toggled = false
  let tags_or_categories = $previews_are_google_fonts ? 'categories' : 'tags'
  
  export let filtered_preview_count
  export let selected_preview_count
  export let compact = false
  
  $: any_or_all = $previews_tags_filter_operator === 'and' ? 'all' : 'any'
  $: any_or_all_switched = $previews_tags_filter_operator === 'and' ? 'any' : 'all'
  $: andor_disabled = $previews_are_google_fonts || $previews_tags_filter.length <= 1
  $: show_unlimited_count = 
    $previews_tags_filter.length === 0 
    && !$previews_search_filter 
    && !$user_valid
    && ($previews_nav_filters.user || isEmpty($previews_nav_filters))
    && $user_installed_fonts_count > $hobby_font_limit
  
  function toggleAndor() {
    if (andor_disabled) return
    $previews_tags_filter_operator = $previews_tags_filter_operator === 'and' ? 'or' : 'and'
    just_toggled = true
  }
</script>

<div class="wrapper">
  <div 
    class="andor"
    class:hovering={hovering && !andor_disabled}
    on:click={toggleAndor} 
    on:mouseenter={() => {if (!andor_disabled) hovering = true}}
    on:mouseleave={() => {hovering = false; just_toggled = false}}>
    {#if hovering && $previews_tags_filter.length > 1 && !just_toggled && $previews_nav_filters.tagged}
      Show fonts with <em>{any_or_all_switched}</em> of the selected {tags_or_categories}
    {:else if show_unlimited_count}
      {#if $previews_nav_filters.user}
        Showing <em>{$hobby_font_limit}</em> of {$user_installed_fonts_count} fonts
      {:else}
        Showing <em>{$detected_fonts.length - ($user_installed_fonts_count - $hobby_font_limit)} </em> of {$detected_fonts.length} fonts
      {/if}
    {:else}
      Showing <em>{filtered_preview_count}</em> {$previews_nav_filters.selected ? 'selected fonts. ' : $detected_fonts === $system_fonts ? 'default system fonts. ' : 'fonts. '}
      {#if $previews_tags_filter.length > 1}with <em>{any_or_all}</em> of the selected {tags_or_categories}{/if}
    {/if}
  </div>
  {#if !compact && !$previews_storefronts_filter}
    <SelectDeselectAll 
      {filtered_preview_count}
      {selected_preview_count}
      on:deselectAllFonts
      on:selectAllFonts/>
    <PreviewsStepperButton on:click={() => modals.open('loadSelection')}>
        {$_('buttons.loadSelection')}
    </PreviewsStepperButton>
  {/if}
</div>

<style>
  .wrapper {
    display: flex;
    gap: 1rem;
    font-variant: lining-nums;
  }
  .andor {
    color: var(--c-text-faded);
  }
  .andor em {
    color: var(--c-text);
    font-style: normal;
  }
  .andor.hovering {
    /* color: var(--c-text); */
    cursor: pointer;
  }
  .andor.hovering em {
    color: var(--c-accent);
  }
</style>